import {
  Content,
  Root
} from "../../../chunk-RAKQ3K3O.mjs";
import {
  clsx_default
} from "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-GYRZVAMU.mjs";
import "../../../chunk-QOCR4XUU.mjs";
import "../../../chunk-D6QHF2UO.mjs";
import "../../../chunk-CD4FQC4X.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Collapse/Collapse.tsx
import { useEffect, useRef, useState } from "react";
import { jsx } from "react/jsx-runtime";
var DEFAULT_DURATION_MS = 280;
var SETTLE_GRACE_MS = 50;
function Collapse({
  in: inProp,
  children,
  timeout,
  collapsedSize = 0,
  className,
  id,
  onSettled,
  ref
}) {
  const [restingOpen, setRestingOpen] = useState(inProp);
  const restingRef = useRef(inProp);
  const settleTimer = useRef(void 0);
  const onSettledRef = useRef(onSettled);
  useEffect(() => {
    onSettledRef.current = onSettled;
  });
  const settle = (open) => {
    clearTimeout(settleTimer.current);
    restingRef.current = open;
    setRestingOpen(open);
    onSettledRef.current?.(open);
  };
  useEffect(() => {
    clearTimeout(settleTimer.current);
    if (restingRef.current === inProp) return;
    settleTimer.current = setTimeout(settle, (timeout ?? DEFAULT_DURATION_MS) + SETTLE_GRACE_MS, inProp);
    return () => clearTimeout(settleTimer.current);
  }, [inProp, timeout]);
  const handleTransitionEnd = (event) => {
    if (event.target === event.currentTarget && restingRef.current !== inProp) settle(inProp);
  };
  const settled = restingOpen === inProp;
  const shutsFully = Number.parseFloat(String(collapsedSize)) === 0;
  const inert = !inProp && settled && shutsFully;
  const style = {
    ...timeout !== void 0 && { "--buyscout-collapse-duration": `${timeout}ms` },
    ...collapsedSize !== 0 && { "--buyscout-collapse-size": typeof collapsedSize === "number" ? `${collapsedSize}px` : collapsedSize }
  };
  return /* @__PURE__ */ jsx(Root, { open: inProp, asChild: true, children: /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      className: clsx_default("buyscout-collapse", className),
      style,
      "data-settled": settled || void 0,
      "data-reveal": timeout === void 0 && shutsFully || void 0,
      onTransitionEnd: handleTransitionEnd,
      children: /* @__PURE__ */ jsx(Content, { forceMount: true, asChild: true, ...id !== void 0 && { id }, children: /* @__PURE__ */ jsx("div", { className: "buyscout-collapse-content", inert, children }) })
    }
  ) });
}
Collapse.displayName = "Collapse";
export {
  Collapse
};
//# sourceMappingURL=Collapse.mjs.map